export default __webpack_public_path__ + "4099f2c8244eea174e9cda2ff051b549.png";